import React from 'react';
import {
  FaUserTie,
  FaTag,
  FaCalendarAlt,
  FaUsers,
} from 'react-icons/fa';
import { Project } from '../services/ProjectService';
import ProjectService from '../services/ProjectService';
import { formatDateDE } from './projectDetailUtils';
import styles from './ProjectDetailPage.module.css';

interface ProjectOverviewTabProps {
  project: Project;
}

export function ProjectOverviewTab({ project }: ProjectOverviewTabProps): React.JSX.Element {
  const hasNoDetails =
    !project.description &&
    !project.notes &&
    !project.responsible_person_name &&
    !project.source &&
    !(project.external_partners_display && project.external_partners_display.length > 0);

  return (
    <div>
      <div className={styles.overviewGrid}>
        {project.responsible_person_name && (
          <div className={styles.overviewInfoCard}>
            <div className={styles.overviewIconCircle}>
              <FaUserTie size={18} color="#021a4a" />
            </div>
            <div>
              <div className={styles.overviewLabel}>Verantwortlich</div>
              <div className={styles.overviewValue}>{project.responsible_person_name}</div>
            </div>
          </div>
        )}

        {project.source && (
          <div className={styles.overviewInfoCard}>
            <div className={styles.overviewIconCircle}>
              <FaTag size={18} color="#021a4a" />
            </div>
            <div>
              <div className={styles.overviewLabel}>Quelle</div>
              <div className={styles.overviewValue}>
                {project.source_display || ProjectService.getSourceLabel(project.source)}
              </div>
            </div>
          </div>
        )}

        {(project.planned_start || project.planned_end) && (
          <div className={styles.overviewInfoCard}>
            <div className={styles.overviewIconCircle}>
              <FaCalendarAlt size={18} color="#021a4a" />
            </div>
            <div>
              <div className={styles.overviewLabel}>Geplanter Zeitraum</div>
              <div className={styles.overviewValue}>
                {formatDateDE(project.planned_start)} - {formatDateDE(project.planned_end)}
              </div>
            </div>
          </div>
        )}
      </div>

      {project.external_partners_display && project.external_partners_display.length > 0 && (
        <div className={styles.sectionMargin}>
          <h4 className={styles.sectionTitle}>
            <FaUsers size={14} />
            Externe Partner / Subunternehmer
          </h4>
          <div className={styles.flexWrap}>
            {project.external_partners_display.map((partner) => (
              <span key={partner.id} className={styles.externalPartnerBadge}>
                {partner.name}
              </span>
            ))}
          </div>
        </div>
      )}

      {project.description && (
        <div className={styles.sectionMargin}>
          <h4 className={styles.sectionTitleSmall}>Beschreibung</h4>
          <p className={styles.description}>{project.description}</p>
        </div>
      )}

      {project.notes && (
        <div className={styles.sectionMargin}>
          <h4 className={styles.sectionTitleSmall}>Notizen</h4>
          <div className={styles.notesBox}>
            <p className={styles.notesText}>{project.notes}</p>
          </div>
        </div>
      )}

      {hasNoDetails && (
        <div className={styles.emptyOverview}>
          <p className={styles.emptyText}>Keine weiteren Details vorhanden.</p>
        </div>
      )}
    </div>
  );
}
